import { GlobalStyle } from "@chakra-ui/react";

export const LightModeAtom = () => {
  return (
    <div data-testid="light-mode-atom">
      <GlobalStyle />
    </div>
  );
};
